// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__SN9NJ","name":"ConsentHeader_name__1It26","birthday":"ConsentHeader_birthday__2HglU","skeleton":"ConsentHeader_skeleton__2bYv6"};